<script setup>
import { useRoute } from "vue-router";
import MainHabb from "./components/MainHabb.vue";
import SiteHeader from "./components/SiteHeader.vue";
import CursHabb from "./components/CursHabb.vue";
import LessonsFreeHabb from "./components/LessonsFreeHabb.vue";
import FooterHabb from "./components/FooterHabb.vue";
import LoginHabb from "./components/LoginHabb.vue";
import RegistrationHabb from "./components/RegistrationHabb.vue";
import ProfileUser from "./components/ProfileUser.vue";

// Получаем текущий маршрут (путь) страницы
const route = useRoute();
</script>
<style></style>

<template>
  <!-- Главный контейнер приложения -->
  <div class="flex flex-col min-h-screen">
    <!-- ЛЕНДИНГ: Показываем, если мы не на страницах логина или регистрации -->
    <!-- prettier-ignore  -->
    <main v-if="route.path !== '/login' && route.path !== '/registration'
    && route.path!== '/profile'" class="flex-1">
      <SiteHeader />
      <MainHabb />
      <CursHabb />
      <LessonsFreeHabb />
      <FooterHabb />
    </main>

    <div v-else-if="route.path === '/registration'" class="flex-1">
      <RegistrationHabb />
    </div>

    <!-- АВТОРИЗАЦИЯ: Показываем только если путь '/login' -->
    <div v-else-if="route.path === '/login'" class="flex-1">
      <LoginHabb />
    </div>

    <!-- Профиль пользователя, показывается когда пользователь авторизирован -->
    <div v-else-if="route.path === '/profile'" class="flex-1">
      <ProfileUser />
    </div>
  </div>
</template>
